module.exports = __webpack_public_path__ + "img/business_17.d753703c.jpg";